var _style;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 12 12",
    style: {
      enableBackground: "new 0 0 12 12"
    },
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css",
    id: "style1651"
  }, ".st0{fill:#fff}")), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2.232 3.262a.344.344 0 0 0 .486 0l.788-.788v2.607a.344.344 0 0 0 .688 0V2.474l.788.788a.344.344 0 0 0 .486-.486L4.093 1.401a.34.34 0 0 0-.486 0L2.232 2.776a.343.343 0 0 0 0 .486zm4.024 1.82H4.538a.687.687 0 1 1-1.375 0h-1.72a.344.344 0 0 0-.343.343v1.031c0 .19.154.344.344.344h4.812c.19 0 .344-.154.344-.344V5.425a.343.343 0 0 0-.344-.344zm-.515 1.116a.259.259 0 0 1-.258-.257c0-.142.116-.258.258-.258.141 0 .257.116.257.258a.259.259 0 0 1-.257.257z",
    id: "path1720",
    style: {
      strokeWidth: 1,
      fill: "#fff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadBg);
export default __webpack_public_path__ + "static/media/upload-bg.dd30a72ee18d6e056f59e51850bcda73.svg";
export { ForwardRef as ReactComponent };